import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { Calendar, DateObject } from 'react-multi-date-picker';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import TextInput from '../../../components/fields/TextInput/TextInput';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import ParkingMeterDTO from '../../../dto/ParkingMeterDTO';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import { StatusHelperTooltip } from './HelperTooltip';
import { optionClassFormatter } from '../../../utils/formatters';
import { PARKING_METER_STATUS } from '../constants';
import { getParkingMetersData } from '../reducer';
import { historyExportWord, hostProblemsDetail, loadHostStatusesHistory } from '../actions';
import {
  responseLogWithNotification, saveFilter,
} from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import StatusHistoryPopup from './StatusHistoryPopup';

const updatePeriods = [
  { value: 0, name: 'Не обновлять' },
  { value: 10, name: '10 секунд' },
  { value: 30, name: '30 секунд' },
  { value: 60, name: '1 минута' },
  { value: 300, name: '5 минут' },
];

window.phsScroll = null;

export default function StatusHistoryPage() {
  const {
    loadingHostStatusesHistoryList,
    hostStatusesHistoryList,
    loadingHistoryExportWord,
    loadingHostStatusDetail,
    loadingZones,
  } = useSelector(getParkingMetersData);
  const momentRangeObject = getDefaultDataRange(1, 'month');
  const dispatch = useDispatch();

  const handleLoadingHostList = opts => {
    const filterData = getValues();
    if (opts && !opts.page) {
      opts.page = 1;
    }
    if (filterData && filterData.date) {
      if (filterData.date.length > 1) {
        filterData.date_from = filterData.date[0].format('YYYY-MM-DD');
        filterData.date_to = filterData.date[1].format('YYYY-MM-DD');
      }
      delete filterData.date;
    }
    Object.keys(filterData).forEach(key => {
      if (!filterData[key]) {
        delete filterData[key];
      }
    });
    saveFilter(filterData, 'status-history-filter');
    const requestData = { filter: filterData };
    if (currentTimeOut) { clearTimeout(currentTimeOut); }
    if (window.location.pathname === '/status-history') {
      dispatch(loadHostStatusesHistory(requestData)).catch(responseLogWithNotification).finally(() => {
        if (updatePeriod) {
          const t = setTimeout(() => handleLoadingHostList(opts), updatePeriod * 1000);
          clearTimeout(window.parkingMetreTimeOut);
          window.parkingMetreTimeOut = t;
        }
      });
    }
  };
  const intl = useIntl();
  const defaultValues = {
    host: '',
    date: momentRangeObject,
    update_period: 0,
  };

  const {
    register, watch, getValues, setValue, reset, resetField,
  } = useForm({
    defaultValues: { ...defaultValues, ...(JSON.parse(localStorage.getItem('status-history-filter')) || {}) },
  });

  watch();
  useEffect(() => {
    const subscription = watch(value => {
      if (!getValues('update_period')) {
        setUpdatePeriod(0);
      }
      handleLoadingHostList();
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  const [updatePeriod, setUpdatePeriod] = useState(0 || getValues('update_period'));
  const [showPopup, setShowPopup] = useState(false);
  const [currentTimeOut, setCurrentTimeOut] = useState(null);
  const [currentHost, setCurrentHost] = useState(null);
  useEffect(() => { handleLoadingHostList(); return () => { clearTimeout(window.parkingMetreTimeOut); }; }, [updatePeriod]);
  useEffect(() => {
    window.phsScroll = new window.IScroll('#scroll-wrapper', {
      scrollbars: false,
      mouseWheel: true,
      scrollX: true,
      scrollY: true,
      interactiveScrollbars: true,
      preventDefault: false,
      // useTransition: false,
      bounce: false,
      momentum: false,
      indicators: [
        {
          el: document.getElementById('vertical-scroll'),
          interactive: true,
          listenX: false,
        },
        {
          el: document.getElementById('horizontal-scroll'),
          interactive: true,
          listenY: false,
        },
      ],
    });
    window.phsScroll.on('scroll', updatePosition.bind(this));
    window.phsScroll.on('moved', updatePosition.bind(this));
    window.phsScroll.on('scrollEnd', updatePosition.bind(this));
  }, []);
  useEffect(() => {
    if (window.phsScroll) {
      window.phsScroll.refresh();
    }
  }, [hostStatusesHistoryList]);

  const DTO = new ParkingMeterDTO();
  const attributes = DTO.getAttributesByName();
  const updatePosition = () => {
    const { style: headerStyle } = document.getElementById('grid-header-list');
    const { style: labelStyle } = document.getElementById('grid-body-labels');
    headerStyle[window.IScroll.utils.style.transform] = `translate(${window.phsScroll.x}px,0px)`;
    labelStyle[window.IScroll.utils.style.transform] = `translate(0px,${window.phsScroll.y}px)`;
  };
  const handleCreateReport = () => {
    const filterData = getValues();
    if (filterData && filterData.date) {
      if (filterData.date.length > 1) {
        filterData.date_from = getValues('date')[0].format('YYYY-MM-DD'); // This DateObject
        filterData.date_to = getValues('date')[1].format('YYYY-MM-DD');
      }
      delete filterData.date;
    }
    Object.keys(filterData).forEach(key => {
      if (!filterData[key]) {
        delete filterData[key];
      }
    });
    const requestData = { filter: filterData };
    dispatch(historyExportWord(requestData)).then(response => {
      if (response.file) {
        window.open(response.file, '_blank');
      }
    }).catch(responseLogWithNotification);
  };

  const handleStatusClick = (status_histories, item) => () => {
    const data = {
      id: status_histories.host_id,
      created_at_from: status_histories.scaled_time,
      created_at_to: status_histories.scaled_time_end,
      host: item.host,
      zbx_address: item.zbx_address,
    };
    setCurrentHost(data);
    dispatch(hostProblemsDetail(data)).then(response => {
      setShowPopup(true);
    }).catch(responseLogWithNotification);
  };

  // eslint-disable-next-line
  const statusHistoryFormatter = i => (status_histories, item) => {
    return (
      <div
        onClick={handleStatusClick(status_histories[i], item)}
        className={classNames(
          'status-cell',
          optionClassFormatter(status_histories && status_histories[i] && status_histories[i].status ? status_histories[i].status : 0),
          { selected: true },
        )}
      >
        &nbsp;
      </div>
    );
  };

  const columns = [];
  if (hostStatusesHistoryList && hostStatusesHistoryList.length) {
    const cols = hostStatusesHistoryList[0].status_histories;
    for (let i = 0, len = cols.length; i < len; i++) {
      const col = cols[i];
      columns.push({
        dataField: 'status_histories',
        text: col.label,
        formatter: statusHistoryFormatter(i),
        disableSort: true,
      });
    }
  }
  columns.push({
    dataField: 'host',
    text: 'Кол-во сбоев',
    formatter: (_, item) => item.status_histories.filter(sh => Number(sh.status) === PARKING_METER_STATUS.ERROR || Number(sh.status) === PARKING_METER_STATUS.WARNING).length,
    disableSort: true,
    dataClassName: 'error-count-data',
    headerClassName: 'error-count-header',
  });

  const gridBodyCell = (row, item, key, rowKey) => {
    let content = row[item.dataField];
    const { bodyStyle = {}, dataClassName = '' } = item;
    if (item.formatter && typeof item.formatter === 'function') {
      content = item.formatter(content, row, rowKey);
    }
    return (
      <div
        key={key}
        style={bodyStyle}
        className={classNames('grid-body-cell', `row-${key}`, dataClassName)}
      >
        {content}
      </div>
    );
  };

  const gridHeaderCell = (item, key) => {
    const { headerStyle = {}, headerClassName } = item;
    let content = item.text;
    if (item.headerFormatter && typeof item.headerFormatter === 'function') {
      content = item.headerFormatter(content, item);
    }
    return (
      <div
        key={key}
        style={headerStyle}
        className={classNames('grid-header-cell', `column-${key}`, headerClassName)}
      >
        <div className={classNames('grid-column')}>
          {content}
        </div>
      </div>
    );
  };
  const firstColumn = (hostStatusesHistoryList && hostStatusesHistoryList.length ? hostStatusesHistoryList : []).map(i => i.host);
  return (
    <div className="parking-meters-page pm-history-status-page content g-0 pb-4">
      <Loader global loading={loadingZones || loadingHistoryExportWord || loadingHostStatusesHistoryList || loadingHostStatusDetail} />
      <PageHeader header="История статусов" />
      <FilterRow className="filter-row">
        <div className="parking-meter-helper">
          <Tooltip
            tooltipContent={<StatusHelperTooltip />}
            content={<Icons customIcon icon="help-outline" className="parking-meter-helper-icon" />}
          />
        </div>
        <CustomSelectInput
          label="Период обновления"
          placeholder="Период обновления"
          dtoObject={attributes.status}
          inputProps={{
            value: getValues('update_period'),
            ...register('update_period'),
            onChange: event => { setValue('update_period', event.target.value || 0); setUpdatePeriod(event.target.value || 0); },
          }}
          className="small parking-meter-state-select no-border"
          options={updatePeriods}
        />
        <FieldWithAttributeDTO
          type="text"
          component={TextInput}
          dtoObject={attributes.host}
          inputProps={{
            ...register('host'),
            value: getValues('host'),
          }}
          className="small no-border"
        />
        <RangeDatePicker
          value={getValues('date')}
          hideSmallButtons
          hidePickerIcon
          showArrowIcon
          handleChangeDate={date => { setValue('date', date); }}
          className="no-border"
        />
        <Button className="export-button" onClick={handleCreateReport}>Сформировать отчёт</Button>
      </FilterRow>
      <div className="frame pm-history-status-table-wrapper">
        <div className="pm-history-status-tw grid-with-scroll">
          <div className="grid-header">
            <div className="grid-header-name">
              <div className="grid-header-cell"><div className="grid-column">Номер паркомата</div></div>
            </div>
            <div className="grid-header-scroll-wrapper">
              <div className="grid-header-list" id="grid-header-list">
                {columns.map(gridHeaderCell)}
              </div>
            </div>
          </div>
          <div className="grid-body">

            <div className="grid-body-labels-scroll-wrapper">
              <div className="grid-body-labels" id="grid-body-labels">
                {firstColumn.map((i, key) => <div key={key} className="grid-body-label">{i}</div>)}
              </div>
            </div>
            <div className="grid-body-data">
              <div className="scroll-wrapper" id="scroll-wrapper">
                <div className="scroll">
                  <div className="body-data">
                    {hostStatusesHistoryList && hostStatusesHistoryList.map((row, rowKey) => (
                      <div
                        key={rowKey}
                        className={classNames('grid-body-row')}
                      >
                        {columns.map((item, key) => (gridBodyCell(row, item, key, rowKey)))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid-scrollbar">
              <div className="vertical-scrollbar scrollbar" id="vertical-scroll">
                <div className="indicator" />
              </div>
              <div className="horizontal-scrollbar scrollbar" id="horizontal-scroll">
                <div className="indicator" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPopup ? <StatusHistoryPopup currentHost={currentHost} handleClose={() => { setShowPopup(false); }} /> : null}
    </div>
  );
}
